const validateAddDocument = values => {
  let errors = {};
  if (!values.name) {
    errors.name = "Please name the document";
  }
  return errors;
};

export default validateAddDocument;
